module.exports = __webpack_public_path__ + "img/product3.16a1b4ad.png";